<span class="fi-icon fi-icon--{{size}} fi-icon--{{color}}">
    <svg aria-hidden="true" focusable="false">
        <use [attr.xlink:href]="id" />
    </svg>
</span>
